import Action from "./Action";


export default [
	{ title: 'File name', field: 'name' },
	{ title: 'Created by', field: 'created_by_name' },
	// { title: 'Fundout file id', field: 'fundout_file_id' },
	{ title: 'Insert record', field: 'inserted_record' },
	{ title: 'Failed record', field: 'failed_record' },
	{ title: 'Created At', field: 'created_at'},
	// { title: 'Updated at', field: 'updated_at' },
	{ title: 'Action', field: 'action',component:Action},

];